import { useObservable } from '@ocodelib/mui/hooks';
import { flatSx } from '@ocodelib/mui';
import { Box, type SxProps } from '@mui/material';
import { useP5BasicApp } from '../../useP5BasicApp';
import { CodeEditorContainer } from './CodeEditorContainer';
import { WorkspaceFileList } from './WorkspaceFileList';

interface Props {
  sx?: SxProps;
}

export function LayoutLeftPane(props: Props) {
  const { sx } = props;
  const { app } = useP5BasicApp();
  const fileList = useObservable(app?.files$) ?? [];
  const fileListVisible = useObservable(app?.fileListVisible$) ?? false;

  return (
    <Box
      className="LayoutLeftPane-root"
      sx={flatSx(
        {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
        sx,
      )}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'stretch',
          flex: 1,
        }}
      >
        {fileListVisible && fileList && fileList.length > 0 && <WorkspaceFileList />}
        <CodeEditorContainer
          sx={{
            height: '100%',
          }}
        />
      </Box>
    </Box>
  );
}
